export default __webpack_public_path__ + "static/tdic-es-06568c30480d092bf881023c48d79998.mp4";